import { axiosClient } from '@/features'
import { LinkPublicKey, SignType, UserProfile } from '@/features/Auth/auth.types'
import { BalanceRespone } from '@/features/Wallets/wallet.types'
import { ApiRoutes } from '@/routes'
import { walletSignMessageAndConvertToBs58 } from '@/shared/helpers/crypto'
import { getUrl } from '@/shared/helpers/url'
import { VersionedTransaction } from '@solana/web3.js'
import bs58 from 'bs58'

export const profileService = {
  getProfile: async (): Promise<UserProfile> => {
    const getProfileReq = await axiosClient.get<UserProfile>(ApiRoutes.GET_USER_PROFILE)
    return getProfileReq.data
  },

  getBalances: async (): Promise<BalanceRespone> => {
    const getBalancesReq = await axiosClient.get<BalanceRespone>(ApiRoutes.GET_USER_WALLET)
    return getBalancesReq.data
  },

  setMainWallet: async (publicKey: string): Promise<{updated: boolean}> => {
    const setWalletReq = await axiosClient.put(getUrl(ApiRoutes.SET_MAIN_WALLET, { pk: publicKey }))
    return setWalletReq.data
  },

  setWalletName: async (publicKey: string, name: string): Promise<{updated: boolean}> => {
    const setWalletNameReq = await axiosClient.put(getUrl(ApiRoutes.SET_WALLET_NAME, { pk: publicKey }), {
      walletName: name,
    })
    return setWalletNameReq.data
  },

  linkPublicKey: async (
    publicKey: string,
    signMessage: (message: Uint8Array) => Promise<Uint8Array>,
    confirmType: SignType,
    signTransaction?: (tx: VersionedTransaction) => Promise<VersionedTransaction>,
  ) => {
    const reqLink = await axiosClient.post<LinkPublicKey>(ApiRoutes.AUTH_LINK_PK, {
      publicKey,
      dataTypeForSign: confirmType,
    })
    const { challenge } = reqLink.data

    let messageToSend = ''

    if (confirmType === SignType.TRANSACTION) {
      const deserializedTx = VersionedTransaction.deserialize(bs58.decode(challenge.rawData))
      const signedTx = await signTransaction(deserializedTx)
      messageToSend = bs58.encode(signedTx.serialize())
    } else {
      messageToSend = await walletSignMessageAndConvertToBs58({ data: challenge.rawData, signMessage })
    }

    const reqVerify = await axiosClient.post(ApiRoutes.AUTH_VERIFY_LINK_PK, {
      publicKey,
      challenge: {
        rawData: challenge.rawData,
        dataForValidate: messageToSend,
        dataType: confirmType,
      },
    })

    return reqVerify.status
  },
}
